import { render, staticRenderFns } from "./BuddycomCallSetting.vue?vue&type=template&id=3440b547&scoped=true"
import script from "./BuddycomCallSetting.vue?vue&type=script&lang=js"
export * from "./BuddycomCallSetting.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallSetting.vue?vue&type=style&index=0&id=3440b547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440b547",
  null
  
)

export default component.exports